// extracted by mini-css-extract-plugin
export default {"header":"PlatformPolicies_header__APtT0"};